import React from 'react';
import { useSelector } from 'react-redux';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import ModalCommonButtonsContainer from '@/components/common-components/ModalComponent/ModalCommonButtonsContainer/ModalCommonButtonsContainer';
import AddCircleOutline from '@/components/Icons/icons/AddCircleOutline';

interface Props {
  isMultiple: boolean;
  onClose: () => void;
  handleBrandSwitch: () => void;
  disabled: boolean;
  loading: boolean;
  handleShowAddNewAccount: () => void;
}

const ButtonsContainer: React.FC<Props> = ({
  isMultiple,
  onClose,
  handleBrandSwitch,
  disabled,
  loading,
  handleShowAddNewAccount,
}) => {
  const { multiBrands } = useSelector((state: any) => state.user);

  if (isMultiple) {
    return (
      <ModalCommonButtonsContainer
        cancelButtonText="Close"
        submitButtonText="Switch"
        onSave={handleBrandSwitch}
        onClose={onClose}
        className={`p-6 ${multiBrands?.length > 4 ? 'upper-shadow' : ''}`}
        disabled={disabled}
        loading={loading}
        secondaryButtonClassName="w-full border-default text-default"
      />
    );
  }

  return (
    <div className="p-6">
      <ButtonComponent variant="primary-outline" className="w-full mb-4" onClick={handleShowAddNewAccount}>
        <AddCircleOutline width={22} height={22} color="var(--icon-highlight)" /> Add New Account
      </ButtonComponent>
      <ButtonComponent variant="secondary" className="w-full border-default" onClick={onClose}>
        <span className="text-base font-medium text-default">Close</span>
      </ButtonComponent>
    </div>
  );
};

export default ButtonsContainer;
